import { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

import { getCities, normalizeLocationList } from "~/services/http/locations";
import {
  locationSelectMenuProps,
  locationSelectSx,
} from "components/Inputs/locationSelectProps";

const CitySelect = (props) => {
  const { value, updateValues, name, disabled = false } = props;
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCities({
      params: {
        ordering: "name",
        limit: 500,
      },
    })
      .then((response) => {
        setCities(
          normalizeLocationList(response).map((city) => ({
            id: city.id,
            name: city.name,
          })),
        );
        setLoading(false);
      })
      .catch(() => {
        setCities([]);
        setLoading(false);
      });
  }, []);

  const handleChange = ({ target }) => {
    updateValues({ [target.name]: { id: target.value } });
  };

  return (
    <TextField
      id="company_city_id"
      select
      label="Kaupunki"
      value={value > -1 ? value : ""}
      name={name}
      onChange={handleChange}
      margin="dense"
      variant="outlined"
      fullWidth
      disabled={disabled || loading || cities.length === 0}
      placeholder={loading ? "Ladataan…" : undefined}
      sx={locationSelectSx}
      slotProps={{
        select: {
          MenuProps: locationSelectMenuProps,
        },
      }}
    >
      {cities.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CitySelect;
